import { lang } from '@umu/ukit-lang';
import { TCooperationRole, ICooperationRole, SwitchString } from '@umu/umu-types';
export type { ICooperationRole, ECooperationRole } from '@umu/umu-types';

export const cooperationLv = {
    creator: 4,
    cooperator: 3,
    operator: 2,
    viewer: 1,
};

export const cooperationShow = {
    hide: 0,
    disabled: 1,
    available: 2,
};

export const cooperationRoleName = {
    creator: lang('拥有者'),
    cooperator: lang('编辑者'),
    operator: lang('运营者'),
    viewer: lang('查看者'),
};

export const defaultCooperationRole = {
    role_type: '' as TCooperationRole,
    is_cooperator: '0' as SwitchString,
    is_manager: false,
};

export const getCooperationRoleName = (roleType?: TCooperationRole) => {
    return roleType ? cooperationRoleName[roleType as 'viewer'] : '';
};

// 管理员有创建者的所有权限
export function hasManagerPermission(role: ICooperationRole) {
    const managerRoleType = `${role?.manager_role_type}`;
    return managerRoleType === '1' || managerRoleType === '2';
}

const getCoursePermission = (role: ICooperationRole): Record<string, number> => {
    let roleLv = cooperationLv[role.role_type as 'viewer'];
    if (role.is_cooperator !== '1') {
        roleLv = 0;
    }
    if (hasManagerPermission(role)) {
        roleLv = cooperationLv.creator;
    }
    return {
        // group menu
        delete: roleLv === cooperationLv.creator ? cooperationShow.available : cooperationShow.disabled,
        recovery: roleLv === cooperationLv.creator ? cooperationShow.available : cooperationShow.disabled,
        deletePermanently: roleLv === cooperationLv.creator ? cooperationShow.available : cooperationShow.disabled,
        downloadOperateLog: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        edit: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        settingMessageNotifications: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        assign: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        ojtAssign: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        screen: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        submitTemplate: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        copy: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        addToProgram: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        ctrl: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        release: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,

        // 左侧导航
        operateLog: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        sessionTrashView: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,

        // pk
        pk_create: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.disabled,
        pk_edit: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        pk_finish: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        pk_revisePoint: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,

        // 其他操作
        addElement: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        enroll_approval: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        reviseStudentPoint: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        editCertificate: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.disabled,

        lecturer_add: roleLv >= cooperationLv.cooperator ? cooperationShow.available : cooperationShow.hide,
        lessonsRecord_add: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.disabled,
        lessonsRecord_operation: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.disabled,
    };
};

const getSessionPermission = (role: ICooperationRole): Record<string, number> => {
    let roleLv = cooperationLv[role.role_type as 'viewer'];
    if (role.is_cooperator !== '1') {
        roleLv = 0;
    }
    if (hasManagerPermission(role)) {
        roleLv = cooperationLv.creator;
    }
    return {
        // session meun
        delete: roleLv === cooperationLv.creator ? cooperationShow.available : cooperationShow.hide,
        deleteBulk: roleLv === cooperationLv.creator ? cooperationShow.available : cooperationShow.disabled,
        edit: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        enrollEdit: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        togglePin: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        downloadOperateLog: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        copyInGroup: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        assign: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        questionBank: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        ojtAssign: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        screen: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        template: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        copy: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        copyOutGroup: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        clearHomework: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        clearHomeworkScore: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        accessPermission: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        accessPermissionBulk: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        accessBulkPermission: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        timing: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        cleanup: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        trial: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        changeScore: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        chapterVisible: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        commentCtrl: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,

        // 左侧导航
        operateLog: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,

        // 小节批量设置
        batchSetting: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        del: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        turnOn: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        turnOff: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        required: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        elective: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,

        // 其他操作
        sort: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        comment_manage: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        live_OBS: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.disabled,
        live_lib: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.disabled,
        video_download: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        video_subtitleSetting: roleLv > cooperationLv.operator ? cooperationShow.available : cooperationShow.hide,
        exam_studentListMarkScore: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.disabled,
        exam_studentDetailMarkScore: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        homework_studentHomeworkManage:
            roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
        photo_ban: roleLv > cooperationLv.viewer ? cooperationShow.available : cooperationShow.hide,
    };
};

export const getCourseActionPermission = (role?: ICooperationRole, key?: string) => {
    if (!key) {
        return cooperationShow.available;
    }
    if (!role) {
        return cooperationShow.hide;
    }
    const permissionMap = getCoursePermission(role);
    return permissionMap.hasOwnProperty(key) ? permissionMap[key] : cooperationShow.available;
};
export const getSessionActionPermission = (role?: ICooperationRole, key?: string) => {
    if (!key) {
        return cooperationShow.available;
    }
    if (!role) {
        return cooperationShow.hide;
    }
    const permissionMap = getSessionPermission(role);
    return permissionMap.hasOwnProperty(key) ? permissionMap[key] : cooperationShow.available;
};
